import { Text, Box } from "@chakra-ui/react";
import ItemsContratosCliente from "./components/ItemsContratosCliente";
import { useListarContratosClientesInfiniteScroll } from "core/features/cliente/hooks/useListarContratosClientesInfiniteScroll";
import { useMemo } from "react";
import { ClienteContrato } from "core/features/cliente/typings";
import { Skeleton } from "@chakra-ui/react";
import { Empty } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import InfiniteScrollLoader from "components/InfiniteScrollLoader";

export default function ContratosCliente() {
  const {
    data: dataContratosClientes,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useListarContratosClientesInfiniteScroll();

  const data = useMemo(() => {
    return (
      dataContratosClientes?.pages.reduce(
        (agg: ClienteContrato[], item) => agg.concat(item.items ?? []),
        []
      ) ?? []
    );
  }, [dataContratosClientes]);

  return (
    <Box>
      <Box mb={4}>
        <Text fontSize={"18px"} fontWeight={"bold"}>
          Contratos do Cliente
        </Text>
        <Text fontSize={"14px"}>
          Clique em um contrato para ver mais detalhes
        </Text>
      </Box>

      {isLoading ? <Skeleton w="100%" h="500px" rounded="10px" /> : null}

      <Box>
        {!isLoading && !data.length ? (
          <Empty description="Sem contratos" />
        ) : null}

        {!isLoading && data.length ? (
          <>
            <InfiniteScroll
              dataLength={data.length}
              next={() => {
                fetchNextPage();
              }}
              hasMore={!!hasNextPage}
              loader={isFetchingNextPage ? <InfiniteScrollLoader /> : null}
            >
              {data.map((item) => (
                <ItemsContratosCliente item={item} key={item.id} />
              ))}
            </InfiniteScroll>
          </>
        ) : null}
      </Box>
    </Box>
  );
}
